import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';

export const API = axios.create();

export const initAPI = (options: { url?: string; timeout?: number; headers?: object; withCredentials?: boolean; }) => {
  API.defaults.baseURL = options.url;
  API.defaults.timeout = options.timeout;
  API.defaults.headers = options.headers;
  API.defaults.withCredentials = options.withCredentials;
};

export async function caller(
  method: 'get' | 'put' | 'post' | 'patch' | 'delete',
  address: string,
  params: AxiosRequestConfig | object = {},
  config: AxiosRequestConfig = {},
): Promise<{ data: unknown }> {
  // @ts-ignore
  const response = await API[method](address, params, config).catch(
    (error: any) => {
      if (error.response) {
        throw error.response.data?.error || error.response;
      }
      throw error;
    },
  );
  return response;
}

export async function GET(
  address: string,
  params: object = {},
  config: AxiosRequestConfig = {},
): Promise<unknown> {
  const response = await caller('get', address, {
    params,
    paramsSerializer: qs.stringify,
    ...config,
  });
  return response.data;
}

export async function PUT(
  address: string,
  params: object = {},
): Promise<unknown> {
  const response = await caller('put', address, params);
  return response.data;
}

export async function POST(
  address: string,
  params: object = {},
  config: AxiosRequestConfig = {}
): Promise<unknown> {
  const response = await caller('post', address, params, config);
  return response.data;
}

export async function PATCH(
  address: string,
  params: object = {},
): Promise<unknown> {
  const response = await caller('patch', address, params);
  return response.data;
}

export async function DELETE(
  address: string,
  params: object = {},
): Promise<unknown> {
  const response = await caller('delete', address, params);
  return response.data;
}
